import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "bell",
  "use": "bell-usage",
  "viewBox": "0 0 65.99 66",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 65.99 66\" id=\"bell\"><title>资源 86</title><g data-name=\"图层 2\"><path d=\"M65 51.26l-8.68-9.77V30.1a25.39 25.39 0 0 0-1.84-9.54 24.76 24.76 0 0 0-5-7.83A23.56 23.56 0 0 0 42 7.42a22.51 22.51 0 0 0-7-1.86V2a2 2 0 0 0-4 0v3.52a22.46 22.46 0 0 0-7.44 1.89 23.46 23.46 0 0 0-7.48 5.31 24.82 24.82 0 0 0-5 7.83 25.38 25.38 0 0 0-1.84 9.54V42L1 51.26a3.89 3.89 0 0 0 2.9 6.48h16.26a14.1 14.1 0 0 0 25.67 0h16.26A3.9 3.9 0 0 0 65 51.26zm-23.64 6.47a10.2 10.2 0 0 1-16.72 0zm11.55-14.2l9.17 10.29H3.91L12.66 44a2 2 0 0 0 .49-1.29V30.1c0-11.44 8.85-20.75 19.64-20.75s19.63 9.31 19.63 20.75v12.13a2 2 0 0 0 .49 1.3z\" data-name=\"图层 1\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/common/bell.svg
// module id = FvmK
// module chunks = 6